<template>
  <v-container fluid class="pt-0 px-0">
    <v-layout row wrap>
      <v-flex xs12 class="flex-container-space-between">
        <div></div>
        <div>
          <v-btn
            icon
            flat
            :color="$store.state.global.pages[$route.name].color"
            @click="sendPagination(1)"
            :disabled="pagination.page == 1"
          >
            <v-icon>first_page</v-icon>
          </v-btn>
          <v-btn
            class="ml-3"
            icon
            flat
            :color="$store.state.global.pages[$route.name].color"
            @click="sendPagination(lastPage)"
            :disabled="pagination.page == lastPage"
          >
            <v-icon>last_page</v-icon>
          </v-btn>
        </div>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  props: {
    pagination: Object
    // totalItems: Number,
    // rowsPerPage: Number,
    // currentPage: Number
  },
  computed: {
    lastPage() {
      if (!this.pagination.totalItems) return 1;
      return Math.ceil(
        this.pagination.totalItems / this.pagination.rowsPerPage
      );
    }
  },
  methods: {
    sendPagination(page) {
      var pagination = {
        ...this.pagination,
        page: page
      };
      this.$emit("page", pagination);
    }
  }
};
</script>

<style>
</style>